import Vue from 'vue'
import Router from '@/common/vueRouter'
import App from '@/product/App.vue'

import { getJsonData } from '@/common/utils/dom'

Vue.use(Router)

const productData = getJsonData('#product-detail-data')

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '*/products/:id',
      component: App,
      props: {
        initData: productData
      }
    }
  ]
})
